__turbopack_context__.v({
  "linkToRules": "SBH3Ja_linkToRules",
  "linkWrapper": "SBH3Ja_linkWrapper",
  "noWrap": "SBH3Ja_noWrap",
  "paragraphWrapper": "SBH3Ja_paragraphWrapper",
});
